(function() {
    var urlSearch = location.search && location.search.replace('?', '').replace(/[\?&]ask=([^&#]*)/ig, '');
    function getData() {
        $.ajax({
            method: 'POST',
            timeout: SR.data.xhrTimeout,
            url: '/theater' + '?' + urlSearch
        })
        .done(function(data) {
            if (data.ret === 0) {
                var theaterScripts = data.data;
                var localTheaterScripts = SR.util.getStorage('theaterScripts');
                if (localTheaterScripts) {
                    if (theaterScripts.length < localTheaterScripts.length) {
                        // 删除多余的剧本
                        localTheaterScripts = localTheaterScripts.slice(0, theaterScripts.length);
                        SR.state.isDebug && console.log('delete theater scripts', theaterScripts);
                    }
                    $(theaterScripts).each(function(index){
                        if (!localTheaterScripts[index] || localTheaterScripts[index].id !== this.id) {
                            // 更新 id 不同的剧本
                            SR.state.isDebug && console.log('update theater scripts', this);
                            localTheaterScripts[index] = this;
                        }
                    });
                } else {
                    // 没有本地剧本，新建剧本
                    SR.state.isDebug && console.log('create theater scripts', theaterScripts);
                    localTheaterScripts = theaterScripts;
                }
                SR.util.updateStorage('theaterScripts', localTheaterScripts);
            }
        })
        .fail(function() {

        })
        .always(function() {

        });
    }
    getData();
})();